export default __webpack_public_path__ + "static/media/coconut.e83a2847.png";